(function () {
  'use strict';

  /* Product page: pick a variant from the chosen options, update price, button and photo. */
  var form = document.getElementById('pdp-form');
  var vjson = document.getElementById('variants-json');
  if (form && vjson) {
    var variants = [];
    try { variants = JSON.parse(vjson.textContent); } catch (e) {}
    var cur = document.documentElement.getAttribute('data-currency') || 'GBP';
    var lang = document.documentElement.lang || 'en-GB';
    var money = function (cents) {
      try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    };
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');

    var chosen = function () {
      return Array.prototype.map.call(form.querySelectorAll('fieldset.opt'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    };
    var update = function () {
      var picks = chosen();
      form.querySelectorAll('fieldset.opt').forEach(function (fs, i) {
        var l = fs.querySelector('[data-opt-label]');
        if (l && picks[i]) l.textContent = picks[i];
      });
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return picks[i] === undefined || picks[i] === null || o === picks[i]; });
      })[0];
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to basket' : 'Sold out';
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
      if (match.featured_image && match.featured_image.position) {
        showPhoto(match.featured_image.position - 1);
      }
    };
    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') update();
    });
  }

  /* Gallery */
  var gallery = [];
  var gj = document.getElementById('gallery-json');
  if (gj) { try { gallery = JSON.parse(gj.textContent); } catch (e) {} }
  var stage = document.getElementById('stage');
  function showPhoto(i) {
    if (!stage || !gallery[i]) return;
    var img = stage.querySelector('img');
    if (img) { img.removeAttribute('srcset'); img.src = gallery[i]; }
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-pressed', String(+t.getAttribute('data-thumb') === i));
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-thumb]') : null;
    if (t) { showPhoto(+t.getAttribute('data-thumb')); return; }

    var q = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (q) {
      var input = q.parentNode.querySelector('input');
      var n = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + parseInt(q.getAttribute('data-qty'), 10)));
      input.value = n;
    }
  });
})();
